import React from 'react';
import Button from 'antd/lib/button';
import { useHistory } from 'react-router-dom';

import './PageNotFound.less';

// IMAGES
import pageNotFoundLight from '../../images/404-page-light.png';
import pageNotFoundDark from '../../images/404-page-dark.png';

export function PageNotFound(props) {
  const { theme, selectBuilding } = props;
  const history = useHistory();

  return (
    <div className={`page-not-found page-not-found-${theme}`}>
      {theme === 'light' ? (
        <img className="page-not-found-image" src={pageNotFoundLight} alt="Page Not Found" />
      ) : (
        <img className="page-not-found-image" src={pageNotFoundDark} alt="Page Not Found" />
      )}
      <p className="page-not-found-text">
        Sorry, we couldn&apos;t find the pi you&apos;re looking for! It either doesn’t exist, isn’t available anymore or
        was made incorrectly.
      </p>
      <div className="page-not-found-buttons-container">
        <Button
          onClick={() => {
            history.push(`/`);
            selectBuilding({});
          }}
          size="large"
          className="page-not-found-continue-button"
        >
          <div className="page-not-found-button-text">Continue to Pi</div>
        </Button>
        <Button
          href="mailto:support@paritygo.com?subject=Parity%20Support%20-%20Unable%20to%20Access%20Page"
          size="large"
          className="page-not-found-contact-button"
        >
          <div className="page-not-found-button-text">Contact Us</div>
        </Button>
      </div>
    </div>
  );
}
